export default theme => ({
    wrapper: {
        width: 'calc(100% - 464px)',
        borderLeft: `1px solid ${theme.palette.grey[500]}`,
        [theme.breakpoints.down('md')]: {
            width: '100%'
        }
    }
});
